var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"industry_zone"},[_c('div',{staticClass:"solid-1200px-width",attrs:{"id":"industry_zone"}},[(_vm.industryZoneData.id === _vm.INDUSTRY_ZONE_ID_MAP.PROPERTY_MANAGEMENT)?_c('IndustryZonePropertyManagement'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }